export default __webpack_public_path__ + "static/media/img2.dcec89e7.jpg";